const actions = {
    FETCH_ATTENDANCE_PERMISSIONS: 'FETCH_ATTENDANCE_PERMISSIONS',
    RESET_ATTENDANCE_PERMISSIONS: 'RESET_ATTENDANCE_PERMISSIONS',

    fetchAttendancePermissionsAction: (data) => {
        return {
            type: actions.FETCH_ATTENDANCE_PERMISSIONS,
            data: data
        };
    },
    resetAttendancePermissionFormAction: () => {
        return {
            type: actions.RESET_ATTENDANCE_PERMISSIONS,
            data: null
        };
    }
};

export default actions;
